export { default as Heading, type HeadingProps, type HeadingVariant } from './Heading'
export { default as Paragraph, type ParagraphProps, type ParagraphVariant } from './Paragraph'
export { default as Tagline, type TaglineProps, type TaglineVariant } from './Tagline'
export {
  type BaseTypographyProps,
  type ResponsiveProps,
  MAX_VIEWPORT,
  MIN_VIEWPORT,
  createCombinedStyles,
  applyResponsiveFontSize,
  applyColorStyling,
} from './typographyUtils'
